import styled from 'styled-components';

const FooterStyle = styled.footer`
	--footerPadTB: var(--sp5x);
	--footerPadLR: var(--sp4x);
	--footerPagesGap: var(--sp8x);
	--footerRightWrapperGap: var(--sp7x);
	--logoMarginB: var(--sp10x);
	--footerImgW: 100%;
	--footerImageSize: 39.4%;
	--logoSizeW: 79%;
	--footerLogoSize: 49.4%;

	position: relative;
	z-index: 7;

	.footer-wrapper {
		background-color: var(--black1000);
		color: var(--white1000);
		padding: var(--footerPadTB) var(--footerPadLR) !important;

		.bottom-links-wrapper {
			display: flex;
			justify-content: space-between;
		}

		.right-wrapper {
			display: flex;
			gap: var(--footerRightWrapperGap);
		}

		/* .footer-imgs-wrapper {
			display: flex;
			justify-content: space-between;
			width: var(--footerImgW);

			.footer-img-wrapper {
				width: var(--footerImageSize);
			}

			.image-cont {
				--proportion: unset;

				img {
					position: unset !important;
					object-fit: contain;
				}
			}
		} */

		.inner-wrapper-logo {
			width: var(--logoSizeW);
			margin-bottom: var(--logoMarginB);

			.image-cont {
				--proportion: var(--footerLogoSize);

				img {
					position: unset !important;
					object-fit: contain;
				}
			}
		}
	}

	.footer-pages-wrapper {
		display: flex;
		gap: var(--footerPagesGap);

		.footer-menu-item-link,
		.footer-menu-item-link-hover {
			font-size: var(--p2);
		}
	}

	.outside-wrapper-footer-menu-item {
		position: relative;
		overflow: hidden;

		.footer-menu-item-link,
		.footer-menu-item-link-hover {
			display: block;
			transition: var(--trTime) ease-out;
			width: 100%;
			height: 100%;
			align-items: center;
			width: 100%;
			height: 100%;
			transition: var(--trTime) ease-out;
			will-change: transform;
		}

		.footer-menu-item-link-hover {
			position: absolute;
			bottom: -100%;
			left: 0;
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					.footer-menu-item-link-hover {
						bottom: 0;
					}

					.footer-menu-item-link {
						transform: translateY(-100%);
					}
				}
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--footerPadTB: var(--sp6x);
		--logoMarginB: var(--sp9x);
		--footerImageSize: 33.4%;
		--footerLogoSize: 38.4%;
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--footerPadTB: var(--sp4x);
		--footerPagesGap: var(--sp7x);
		--logoMarginB: var(--sp7x);
		--logoSizeW: 97%;
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--footerPadLR: var(--sp3x);
		--logoMarginB: var(--sp6x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--footerPadTB: var(--sp3x);
		--footerPagesGap: var(--sp6x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--footerPadLR: var(--sp2x);
		--footerPagesGap: var(--sp5x);
		--logoMarginB: var(--sp5x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--footerPadTB: var(--sp2x);
		--footerPagesGap: var(--sp4x);
		--logoMarginB: var(--sp4x);
		--footerLogoSize: 26.4%;
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--footerPadTB: var(--sp3x);
		--footerPadLR: var(--sp1-5x);
		--footerPagesGap: var(--sp3x);
		--footerRightWrapperGap: var(--sp1-5x);
		--logoSizeW: 79%;
		--footerLogoSize: 42.4%;

		.footer-pages-wrapper,
		.bottom-links-wrapper,
		.right-wrapper {
			flex-direction: column;
		}

		.empty-div {
			display: none;
		}

		.bottom-links-wrapper {
			gap: var(--footerRightWrapperGap);
		}
	}
`;

export default FooterStyle;
